import { render, staticRenderFns } from "./sco-tips.vue?vue&type=template&id=bc7d7b8c&"
import script from "./sco-tips.vue?vue&type=script&lang=js&"
export * from "./sco-tips.vue?vue&type=script&lang=js&"
import style0 from "./sco-tips.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports